import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import { formatarCNPJ, formatarDataSimples } from '@spark/utils/formatters';

export const getTabelaPrecoClienteColumns = (onSelect, onRemove, loadingSelectId, loadingRemoveId) => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    size: 80,
    cell: ({ row }) => row.original.id ?? '-'
  },
  {
    id: 'nome',
    accessorKey: 'nome',
    header: 'Nome',
    size: 220,
    cell: ({ row }) => row.original.nome || '-'
  },
  {
    id: 'cnpjCliente',
    accessorKey: 'cnpjCliente',
    header: 'CNPJ',
    size: 160,
    cell: ({ row }) => formatarCNPJ(row.original.cnpjCliente || '')
  },
  {
    id: 'tipoOperacao',
    accessorKey: 'tipoOperacao',
    header: 'Tipo Operacao',
    size: 200,
    cell: ({ row }) => row.original.tipoOperacao || '-'
  },
  {
    id: 'dataCriacao',
    accessorKey: 'dataCriacao',
    header: 'Data Criacao',
    size: 130,
    cell: ({ row }) =>
      row.original.dataCriacao ? formatarDataSimples(row.original.dataCriacao) : '-'
  },
  {
    id: 'dataAtualizacao',
    accessorKey: 'dataAtualizacao',
    header: 'Data Atualizacao',
    size: 130,
    cell: ({ row }) =>
      row.original.dataAtualizacao ? formatarDataSimples(row.original.dataAtualizacao) : '-'
  },
  {
    id: 'acoes',
    header: 'Acoes',
    size: 180,
    cell: ({ row }) => (
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip dir="top" text="Selecionar">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="primary"
              size="sm"
              loading={loadingSelectId === row.original.id}
              disabled={loadingSelectId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onSelect(row.original.id);
              }}
            >
              <Icon name="check" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
        <Tooltip dir="top" text="Remover">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-danger"
              size="sm"
              loading={loadingRemoveId === row.original.id}
              disabled={loadingRemoveId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onRemove(row.original.id);
              }}
            >
              <Icon name="trash" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
      </div>
    ),
    enableSorting: false
  }
];
